import { getCookie } from '@/utils/cookie';
import { isSayWeeeApp } from '@/utils/common/device';
import Constants from '@/constants/const';
import callAppFunction from '../bridge';

/**
 * @description: 深度合并对象
 * @param {object} target 目标对象
 * @param {object} source 源对象
 * */
export const deepMerge = (target: ObjectType, source: ObjectType) => {
  const result = { ...target };
  for (const key of Object.keys(source)) {
    if (result[key] && typeof result[key] === 'object') {
      result[key] = deepMerge(result[key], source[key]);
    } else {
      result[key] = source[key];
    }
  }
  return result;
};
/**
 * 获取app context
 * @returns app context对象
 */
export const getAppContext = (ctx?): AppContext => {
  try {
    const context = getCookie(Constants.APP_CONTEXT);
    if (context) {
      return JSON.parse(context);
    }
  } catch (err) {
    return {
      page_key: ''
    };
  }
};
/**
 * 可以理解为异步执行
 * requestIdleCallback 是浏览器空闲时会自动执行内部函数
 * requestAnimationFrame 是浏览器必须执行的
 * 关于 requestIdleCallback 和  requestAnimationFrame 可以参考 https://www.cnblogs.com/cangqinglang/p/13877078.html
 */
export const nextTick = (callback: any, delay: number = 17) => {
  if (typeof window.requestIdleCallback === 'function') {
    window.requestIdleCallback(callback, { timeout: delay });
  } else if (typeof requestAnimationFrame === 'function') {
    window.requestAnimationFrame(callback);
  } else if (typeof window.Promise === 'function') {
    Promise.resolve().then(callback);
  } else setTimeout(callback, delay);
};
/**
 * 传值为null或者undefined时返回null，否则返回原值
 * @param value 传入值
 */
export const formatNullish = (value: any) => (value === null || value === undefined ? null : value);

/**
 * @description: 格式化对象,将对象中的null和undefined转换为null,保留0，false,空字符串
 * */
export const formatObject = (value: any = {}): Record<string, any> => {
  let temp = {};
  if (value && typeof value === 'object') {
    for (let key in value) {
      if (value.hasOwnProperty(key)) {
        if (typeof value[key] === 'object' && value[key] !== null) {
          temp[key] = formatObject(value[key]);
        } else temp[key] = formatNullish(value[key]);
      }
    }
  }
  return temp;
};

/**
 * 通过app函数设置新的上下文
 * @param context app存放在请求头上的上下文
 */
export const setAppContext = (context: AppContext) => {
  if (isSayWeeeApp()) {
    callAppFunction('setPageContext', JSON.stringify(context));
  }
};

/** 关闭pv弹窗时纠正page_key,referral */
export const closePvModal = () => {
  window._weeeTracker?.correctModalPageContext?.();
};
export interface AppContext {
  page_key?: string;
  device_id?: string;
  page_url?: string;
  view_id?: string;
  page_ctx_app?: Record<string, any>;
  os_version?: string;
  os_language?: string;
}
